
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useForm } from "@/context/FormContext";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";
import { useTranslation } from "react-i18next";

interface TimePickerFieldProps {
  element: FormFieldType;
}

export const TimePickerField: React.FC<TimePickerFieldProps> = ({ element }) => {
  const { formData, setField } = useForm();
  const { t } = useTranslation();
  
  // Extract hour and minute from stored value if it exists
  const value = formData[element.name!] as string || "";
  const [hour, minute] = value ? value.split(":") : ["", ""];

  const handleHourChange = (newHour: string) => {
    const newValue = `${newHour}:${minute || "00"}`;
    setField(element.name!, newValue);
  };

  const handleMinuteChange = (newMinute: string) => {
    const newValue = `${hour || "09"}:${newMinute}`;
    setField(element.name!, newValue);
  };

  // Generate hours from 06 to 22
  const hours = Array.from({ length: 17 }, (_, i) => {
    const hourValue = i + 6;
    return hourValue < 10 ? `0${hourValue}` : `${hourValue}`;
  });

  // Minutes options are 00 and 30
  const minutes = ["00", "30"];

  return (
    <FieldWrapper element={element}>
      <div className="flex space-x-2">
        <div className="flex-1">
          <Select
            value={hour}
            onValueChange={handleHourChange}
          >
            <SelectTrigger>
              <SelectValue placeholder={t('form.fields.timeHour')} />
            </SelectTrigger>
            <SelectContent>
              {hours.map((h) => (
                <SelectItem key={h} value={h}>{h}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center">:</div>
        <div className="flex-1">
          <Select
            value={minute}
            onValueChange={handleMinuteChange}
          >
            <SelectTrigger>
              <SelectValue placeholder={t('form.fields.timeMinute')} />
            </SelectTrigger>
            <SelectContent>
              {minutes.map((m) => (
                <SelectItem key={m} value={m}>{m}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </FieldWrapper>
  );
};

export default TimePickerField;
